import { DictUtil } from 'jczh-ui'

// 文本搜索模式
export const textSearchModeDict = new DictUtil({
  BODY: { label: '正文', value: 1 },
  TITLE: { label: '标题', value: 2 },
  ORDER_NAME: { label: '项目名称', value: 3 },
  COMPANY_NAME: { label: '采购单位名称', value: 4 }
})

// 公告来源
export const noticeResourceDict = new DictUtil({
  JCZH: { label: '精彩纵横云采购', value: 1 },
  PUBLIC_SOURCE: { label: '全国公共资源交易网', value: 2 },
  PUBLIC_SERVICE: { label: '中国招标投标公共服务平台', value: 3 },
  PUBLIC_JX: { label: '江西省公共资源交易中心', value: 4 },
  PUBLIC_GX: { label: '广西公共资源交易平台', value: 5 },
  PUBLIC_GZ: { label: '广州公共资源交易中心', value: 6 }
})

// 公告类型
export const noticeTypeDict = new DictUtil({
  PURCHASE_INTENTION: {
    label: '采购意向公告',
    value: 6,
    type: 'warning',
    dynamicLabel: '采购意向'
  },
  PURCHASE: {
    label: '采购公告',
    value: 3,
    type: 'primary',
    dynamicLabel: '发布'
  },
  CHANGE: {
    label: '变更公告',
    value: 4,
    type: 'warning',
    dynamicLabel: '变更'
  },
  CANDIDATE: {
    label: '候选公告',
    value: 1,
    type: 'primary',
    dynamicLabel: '候选'
  },
  MAKE_A_DEAL: {
    label: '成交公告',
    value: 2,
    type: 'success',
    dynamicLabel: '成交'
  },
  FLOW_MARK: {
    label: '流标公告',
    value: 5,
    type: 'info',
    dynamicLabel: '流标'
  },
  PURCHASE_CONTRACT: {
    label: '采购合同',
    value: 7,
    type: 'success',
    dynamicLabel: '合同'
  },
  OTHER: {
    label: '其他公告',
    value: -1,
    type: 'primary',
    dynamicLabel: '其他'
  }
})

// 文本搜索模式
export const textSearchModeDict2 = new DictUtil({
  TITLE: { label: '标题', value: 2 },
  BODY: { label: '正文', value: 1 },
  ORDER_NAME: { label: '项目名称', value: 3 },
  COMPANY_NAME: { label: '采购单位名称', value: 4 }
})
